import { render, staticRenderFns } from "./ServicesTypeDelete.vue?vue&type=template&id=6297d2b8&scoped=true&"
import script from "./ServicesTypeDelete.vue?vue&type=script&lang=js&"
export * from "./ServicesTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297d2b8",
  null
  
)

export default component.exports